import type { BaoCaoTho } from '../modules/bao-cao/types';

/** Dữ liệu mẫu thô của `/bao-cao`; không mang màu, việc gom do `tongHop` làm. */
const loai = (ma: string, n: number) => Array.from({ length: n }, () => ma);

export const MOCK_BAO_CAO: BaoCaoTho = {
  chungTu: { total: 1284, confirmed: 742, transferred: 359 },
  soMauOcr: 12,
  loaiChungTu: [
    ...loai('INVOICE', 540),
    ...loai('CONTRACT', 310),
    ...loai('RECEIPT', 180),
    ...loai('WAREHOUSE_RECEIPT', 120),
    ...loai('MINUTES', 90),
    ...loai('OTHERS', 44),
  ],
  khoStats: { tongBo: 7, tongTep: 1576, phongBan: 4 },
  khoList: [
    { name: 'Quy trình kế toán nội bộ', totalFiles: 412, pdf: 250 },
    { name: 'Chính sách nhân sự', totalFiles: 318, pdf: 190 },
    { name: 'Hợp đồng mẫu và điều khoản chuẩn áp dụng toàn công ty', totalFiles: 276, pdf: 200 },
    { name: 'Báo cáo tài chính theo quý', totalFiles: 198, pdf: 120 },
    { name: 'Nghị quyết Ban Giám đốc', totalFiles: 154, pdf: 150 },
    { name: 'Tài liệu đào tạo nội bộ', totalFiles: 131, pdf: 40 },
    { name: 'Hồ sơ nhà cung cấp', totalFiles: 87, pdf: 30 },
  ],
  chatbots: [
    { active: true, answerable: true, mode: 'knowledge_only', scenariosEnabled: true },
    { active: true, answerable: true, mode: 'knowledge_only', scenariosEnabled: false },
    { active: true, answerable: false, mode: 'open', scenariosEnabled: false },
    { active: false, answerable: false, mode: 'open', scenariosEnabled: false },
  ],
  nguoiDung: [
    ...Array.from({ length: 18 }, () => ({ departmentId: 'pb-1', active: true })),
    ...Array.from({ length: 14 }, () => ({ departmentId: 'pb-2', active: true })),
    ...Array.from({ length: 9 }, () => ({ departmentId: 'pb-3', active: true })),
    ...Array.from({ length: 6 }, () => ({ departmentId: 'pb-3', active: false })),
    ...Array.from({ length: 5 }, () => ({ departmentId: null, active: true })),
  ],
  soVaiTro: 9,
  phongBan: [
    { id: 'pb-1', name: 'Phòng Kế toán' },
    { id: 'pb-2', name: 'Phòng Nhân sự' },
    { id: 'pb-3', name: 'Phòng Kinh doanh' },
  ],
  soLoi: 0,
};

export const BAO_CAO_RONG: BaoCaoTho = {
  chungTu: { total: 0, confirmed: 0, transferred: 0 },
  soMauOcr: 0,
  loaiChungTu: [],
  khoStats: { tongBo: 0, tongTep: 0, phongBan: 0 },
  khoList: [],
  chatbots: [],
  nguoiDung: [],
  soVaiTro: 0,
  phongBan: [],
  soLoi: 0,
};
